// ---------------------------------------------- modules import
import { FirebaseReducer, firebaseReducer } from "react-redux-firebase";
import { Reducer, combineReducers } from "redux";
import { firestoreReducer } from "redux-firestore";

import { IAlbumState } from "./album/common";
import albumReducer from "./album/reducer";
import { IAuthState } from "./auth/common";
import authReducer from "./auth/reducer";
import { IUserData } from "./firebase/common";
import { IPinnedPostState } from "./pinnedPost/common";
import pinnedPostReducer from "./pinnedPost/reducer";
import { IPostState } from "./post/common";
import bodPostReducer from "./post/reducer";
import commonPostReducer from "./post/reducer";
import exclusivePostReducer from "./post/reducer";
import fadPostReducer from "./post/reducer";
import fssPostReducer from "./post/reducer";
import generalPostReducer from "./post/reducer";
import hrgaPostReducer from "./post/reducer";
import locPostReducer from "./post/reducer";
import managementPostReducer from "./post/reducer";
import marketingPostReducer from "./post/reducer";
import productionPostReducer from "./post/reducer";
import storePostReducer from "./post/reducer";
import supportingPostReducer from "./post/reducer";
import { IUserState } from "./user/common";
import userReducer from "./user/reducer";

// ---------------------------------------------- root reducer
export interface AppState {
  album: IAlbumState;
  auth: IAuthState;
  bodPost: IPostState;
  commonPost: IPostState;
  exclusivePost: IPostState;
  fadPost: IPostState;
  firebase: FirebaseReducer.Reducer<
    Record<string, Record<string | number, string | number>>,
    IUserData
  >;
  firestore: any;
  fssPost: IPostState;
  generalPost: IPostState;
  hrgaPost: IPostState;
  locPost: IPostState;
  managementPost: IPostState;
  marketingPost: IPostState;
  pinnedPost: IPinnedPostState;
  productionPost: IPostState;
  storePost: IPostState;
  supportingPost: IPostState;
  user: IUserState;
  [key: string]: any;
}

const rootReducer: Reducer<AppState> = combineReducers<AppState>({
  album: albumReducer,
  auth: authReducer,
  bodPost: bodPostReducer,
  commonPost: commonPostReducer,
  exclusivePost: exclusivePostReducer,
  fadPost: fadPostReducer,
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  fssPost: fssPostReducer,
  generalPost: generalPostReducer,
  hrgaPost: hrgaPostReducer,
  locPost: locPostReducer,
  managementPost: managementPostReducer,
  marketingPost: marketingPostReducer,
  pinnedPost: pinnedPostReducer,
  productionPost: productionPostReducer,
  storePost: storePostReducer,
  supportingPost: supportingPostReducer,
  user: userReducer
});

export default rootReducer;
